import * as yup from 'yup';

export const validationSchema = yup.object({
  answers: yup.array().test('first-question-validation', 'Обязательное поле', function (answers) {
    const { path, createError } = this;

    //TODO Убрать хардкод, когда на беке будут приходить обязательные  вопросы
    const needQuestion = answers?.find((item) => item?.['mark']);
    const needAnswer = needQuestion ? needQuestion['mark'] : null;

    if (!needQuestion || !needAnswer) {
      return createError({
        path: `${path}[0].mark`,
        message: 'Обязательное поле',
      });
    }

    return true;
  }),
});
